import React from 'react';
import PropTypes from 'prop-types';

import {blue500} from "assets/jss/main";

CountBadge.propTypes = {
    count: PropTypes.number
};

function CountBadge({count}) {
    return (
        <div style={{
            position: 'absolute',
            fontSize: '10px',
            fontWeight: 'bold',
            background: blue500,
            borderRadius: '999px',
            width: '16px',
            height: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            right: '-5px',
            top: '-5px',
        }}>
            {count}
        </div>
    );
}

export default CountBadge;
